import { render } from "./CrashMark.vue?vue&type=template&id=6a8c657e"
import script from "./CrashMark.vue?vue&type=script&lang=js"
export * from "./CrashMark.vue?vue&type=script&lang=js"

import "./CrashMark.vue?vue&type=style&index=0&id=6a8c657e&lang=css"
script.render = render

export default script